import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { parsePhoneNumber } from 'libphonenumber-js';

import { Store } from '@ngrx/store';

import { IChannel } from '../../interfaces/IChannel';
import { changeChannelPhone } from '../../store/chat.actions';
import { AppStateWithChat } from '../../store/chat.reducer';

@Component({
  selector: 'ngx-messaging-phone-edit-form',
  templateUrl: './phone-edit-form.component.html',
  styleUrls: ['./phone-edit-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PhoneEditFormComponent {
  private fb = inject(FormBuilder);
  private store = inject(Store<AppStateWithChat>);
  private dialogRef = inject(MatDialogRef<PhoneEditFormComponent>);
  data = inject<{ channel: IChannel }>(MAT_DIALOG_DATA);

  phoneControl: FormControl = this.fb.control(this.data.channel.phoneNumber, [Validators.required]);
  phoneForm: FormGroup = this.fb.group({
    phoneNumber: this.phoneControl,
  });

  save(): void {
    const phoneNumber = parsePhoneNumber(this.phoneForm.value['phoneNumber'] as string)
      .format('E.164')
      .toString();
    this.store.dispatch(
      changeChannelPhone({
        channel: this.data.channel,
        phoneNumber,
        oldPhone: this.data.channel.phoneNumber ?? '',
      })
    );
    this.close();
  }

  close(): void {
    this.dialogRef.close();
  }
}
